/**
 * Generate and download an .xlsx template for the Session Library bulk upload.
 *
 * The template contains:
 *  - Sheet "Sessions" with columns SN, Session No, Session Name (20 pre-filled rows)
 *  - Sheet "Metadata" with the current Semester / Class / Module Code / Module Name
 *
 * The parser in SessionsBulkCreateDialog only reads "Session No" and "Session Name";
 * "SN" is informational only.
 */
export async function downloadSessionLibraryTemplate(opts: {
  semester: string;
  class: string;
  moduleCode: string;
  moduleName?: string | null;
  rows?: number;
}) {
  const XLSX = await import("xlsx");
  const rows = Math.max(1, opts.rows ?? 20);

  const sessionsData = [
    ["SN", "Session No", "Session Name"],
    ...Array.from({ length: rows }, (_, i) => [i + 1, i + 1, ""]),
  ];
  const wsSessions = XLSX.utils.aoa_to_sheet(sessionsData);
  (wsSessions as any)["!cols"] = [{ wch: 6 }, { wch: 12 }, { wch: 60 }];

  const metaData = [
    ["Field", "Value"],
    ["Semester", opts.semester],
    ["Class", opts.class],
    ["Module Code", opts.moduleCode],
    ["Module Name", opts.moduleName ?? ""],
    ["Generated", new Date().toISOString()],
  ];
  const wsMeta = XLSX.utils.aoa_to_sheet(metaData);
  (wsMeta as any)["!cols"] = [{ wch: 16 }, { wch: 50 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, wsSessions, "Sessions");
  XLSX.utils.book_append_sheet(wb, wsMeta, "Metadata");

  const safe = (s: string) => (s || "").replace(/[^A-Za-z0-9_-]+/g, "_");
  const filename = `SessionLibrary_${safe(opts.class)}_${safe(opts.moduleCode)}_Sem${safe(opts.semester)}.xlsx`;
  XLSX.writeFile(wb, filename);
}
